<template>
  <div class='content-viz contenedor-grafica'>
      <div class="tablero-cabecera">
        <div class="instruccional">
            <h2 class="titulo">Red de transmisión</h2>
            <span class="fecha">{{obtenerFechaActualizacion}}</span>
            
        </div>
        <button type="button" class="boton-modal" @click="$refs.modal_transmision.abrirModal()">
            Acerca de la gráfica
        </button>
        <modal ref="modal_transmision" :posicion_boton="'arriba'">
            <template v-slot:cuerpo>
            <p>Las redes genéticas de transmisión de VIH pueden ayudar a identificar conglomerados que se encuentran en crecimiento activo en el tiempo. En esta gráfica, cada círculo representa a una persona que se encuentra dentro de la red. Los círculos están ordenados por edad y por el momento en el tiempo en que se incorporaron a la red. Mientras más arriba se encuentren, más reciente es su incorporación. Cada círculo está unido con otros que forman parte de un mismo conglomerado, estos vínculos establecen relaciones de distancia genética menor a 1.5% entre las secuencias virales de las personas representadas. Mientras más grande sea un círculo, más enlaces tiene la persona con otras. Los círculos están coloreados por la presencia de resistencia basal a fármacos antirretrovirales. Algunas características específicas de cada persona que se incorpora a la red pueden observarse pasando el cursor sobre el círculo correspondiente. </p>
            </template>
        </modal>
        
    </div>
    <div class="tablero-cuerpo" :class="{open: notas_open}">
        <Loader v-if="loader_visible"/>
        <div class="panel-lateral-nomenclatura">
            <div class="panel-porcentaje-muestra">
                <div class="porcentaje-descripcion">
                    <p class="porcentaje-absoluto">
                        <b>Personas que son parte de algún conglomerado: </b> 
                        {{Math.round(1000 * personas_parte_conglomerado/personas_total)/10}}% ({{personas_parte_conglomerado.toLocaleString("en")}})
                    </p>
                    <p class="porcentaje-total"><b>Muestra total:</b> {{personas_total.toLocaleString("en")}} participantes </p>
                </div>
            </div>
            <NomenclaturaResistencia class="contenedor-check"
                :titulo='"Resistencia"'
                :descripcion='"Tipo de antirretroviral al que presenta resistencia"'
                :opciones="opciones_antirretroviral"
            />
            <NomenclaturaDistanciaGenetica
                titulo="Distancia genética (%)"
                :cortes_distancia_genetica= "cortes_distancia_genetica"
            />
            <NomenclaturaGrado
                titulo="Número de conexiones por participante (grado)"
                :cortes_grado= "cortes_grado"
            />
        </div>
        <div class="contenedor-tooltip-svg" :id="id_red_temporal">
            <div class="eje-x">
                <p  v-html="titulo_eje_x" :style="{
                    padding: `${0}px ${margen.derecha}px 0 ${margen.izquierda + ancho_leyenda_y}px `
                }"></p>      
            </div>
            <div class="rotation-wrapper-outer">
                <div class="rotation-wrapper-inner">
                    <div class="element-to-rotate" :style="{width: `${alto + margen.arriba }px`,
                    transform: `rotate(-90deg)translateX(calc(-100% - ${.5 * margen.arriba}px))`}">
                        <p style="padding:10px 0 5px 0" v-html="titulo_eje_y"></p>
                    </div>
                </div>    
            </div>
            <canvas id="canvas_red">
            </canvas>
            <div class="tooltip" :style="{width: ancho_tooltip+'px'}">
                <div class="tooltip-contenido">
                    <div class="tooltip-encabezado">
						<button class="boton-cerrar-tooltip" @click="cerrarTooltip">
							<img src="@/assets/img/cerrar.svg"/>
						</button>
					</div>
					<div class="tooltip-cuerpo"></div>
                </div>
            </div>
            <svg id="svg_red">
                <defs>
                </defs>
                <g class="eje-x"></g>
                <g class="eje-y"></g>
                <g class="sin-dato">
                    <text>Sin dato</text>
                    <rect>

                    </rect>
                </g>
                <g class="elementos-mouse">
                    
                    <circle class="circulo-mousemove"></circle>
                </g>
                <rect class="rect-over"></rect>
            </svg>
        </div>
    </div>
    
    <button aria-hidden="true" class="summary" @click="notas_open=!notas_open" type="button">
            {{notas_open ? "Contraer visualización": "Mostrar visualizacion completa"}}
        </button>

  </div>
</template>

<script>
import * as d3 from 'd3';
import { mapGetters, mapState } from 'vuex';
import NomenclaturaResistencia from "@/components/red-transmision/nomenclaturas/NomenclaturaResistencia.vue"
import NomenclaturaDistanciaGenetica from "@/components/red-transmision/nomenclaturas/NomenclaturaDistanciaGenetica.vue"
import NomenclaturaGrado from "@/components/red-transmision/nomenclaturas/NomenclaturaGrado.vue"
import Modal from '@/components/base/Modal.vue';
import Loader from '@/components/mapa/utiles/loader.vue'


var lista_meses_abr = [
	"ene",
	"feb",
	"mar",
	"abr",
	"may",
	"jun",
	"jul",
	"ago",
	"sep",
	"oct",
	"nov",
	"dic",
]

export default {
  name: 'RedTemporal',
  components:{
      NomenclaturaResistencia,
      NomenclaturaDistanciaGenetica,
      NomenclaturaGrado,
      Modal,
      Loader
  },
  data() {
    return {
        loader_visible: true,
        notas_open: false,
        id_red_temporal:"id_red_temporal",
        alto:10,
        titulo_eje_y: "Fecha de toma de muestra",
        titulo_eje_x: "Edad (años)",
        opciones_antirretroviral: [
        {'id': 'cat-1', 'texto': 'Sin resistencia','valor': 'Sin resistencia','color': '#A726F5'},
        {'id': 'cat-2', 'texto': 'NNRTI','valor':'NNRTI','color': '#D62216'},
        {'id': 'cat-3', 'texto': 'Compleja','valor':'Compleja','color': '#445DE1'},
        {'id': 'cat-4', 'texto': 'NRTI','valor':'NRTI','color': '#E96C41'},
        {'id': 'cat-5', 'texto': 'INSTI','valor':'INSTI','color': '#703117'},
        {'id': 'cat-6', 'texto': 'PI','valor':'PI','color': '#DEB74D'}
      ],
      cortes_distancia_genetica: [
        {'id': 'cat-1', 'texto': '0 a 0.5','rango': [0,0.5], "dash_array":"","stroke_color":"rgba(0, 0, 0, .5)","stroke_width":"1px"},
        {'id': 'cat-2', 'texto': '0.5 a 1','rango': [0.5,1], "dash_array":"","stroke_color":"rgba(180, 180, 180, .5)","stroke_width":"1px"},
        {'id': 'cat-3', 'texto': '1 a 1.5','rango': [1,1.5],"dash_array":"4, 4", "stroke_color":"rgba(180, 180, 180, .5)","stroke_width":"1px"},
      ],
      cortes_grado:[
        {'id': 'cat-1', "valor":1, "diametro":2, color:"#333333"},
        {'id': 'cat-1', "valor":2, "diametro":2, color:"#333333"},
        {'id': 'cat-1', "valor":6, "diametro":2, color:"#333333"},
        {'id': 'cat-1', "valor":15, "diametro":2, color:"#333333"},
        {'id': 'cat-1', "valor":30, "diametro":2, color:"#333333"},
      ],

        iniciaBusquedaCluster: Function,
        dicColores: {
          'Sin resistencia':'#A726F5',
          'NNRTI':'#D62216',
          'Compleja': '#445DE1',
          'NRTI':'#E96C41',
          'INSTI':'#703117',
          'PI': '#DEB74D'},
        datos: {},
        factor_escala_radial: .00002,
        formatoTemporal: d3.timeParse('%Y-%m-%d'),
        margen: {
            arriba: 50,
            abajo: 40,
            derecha: 40,
            izquierda: 30
        },
        columna_visualizar: "edad",
        radio : 1.5,
        data_nodos:[],
        data_enlaces:[],
        cluster_clickeado: null,
        ancho_tooltip: 250,
        ancho_leyenda_y:0,
        personas_parte_conglomerado: Number,
        personas_total: Number


    };
  },
  watch:{
        columna_visualizar(){
            this.creandoEscalas();
            this.context.globalAlpha = .8
            d3.timer(this.dibujandoCanvas)
            this.reconfigurandoEnlaces(this.data_enlaces);

            this.reconfigurandoNodos(this.data_nodos);

        },
        vistaSimplificada(nv) {
      if (nv == false) {
        this.reescalandoPantalla();
      }
    },
  },
  mounted() {
    this.svg = d3.select("svg#svg_red")
    this.defs = this.svg.select("defs")
    this.creandoShadows()
    this.rectangulo_over = this.svg
        .select("rect.rect-over")
    this.svg.select("g.elementos-mouse")
        .attr("transform", `translate(${this.margen.izquierda},${this.margen.arriba})`)
    this.circulo_over = this.svg
        .select("circle.circulo-mousemove")
    this.grupo_sin_dato =this.svg.select("g.sin-dato")

    this.eje_x = this.svg
        .select('g.eje-x');
    this.eje_y = this.svg
        .select('g.eje-y');
    this.canvas = d3.select("canvas#canvas_red")
    this.tooltip = d3.select("div.contenedor-tooltip-svg div.tooltip")
    this.context = this.canvas.node().getContext("2d")
    this.configurandoDimensionesCanvas()

    

    
    d3.json('data/tablero_red.json')
        .then((data) => {
            let tiempo_fin_simulacion = Date.now() + 5500;
            data.nodes.forEach((d)=>{
                d.fech = this.formatoTemporal(d.fecha_toma)
            })
            this.personas_total = data.nodes.length
            
            this.datos = data;
            this.data_nodos = data.nodes.filter(d => d.cluster_id != null && d.cluster_id != 0)
            //.filter(d => !d[this.columna_visualizar]== false);
            this.personas_parte_conglomerado = this.data_nodos.length
            this.data_enlaces = data.links;
            
            this.creandoEscalas();
            
            
            this.creandoSimulacion();
            this.creandoEjes();


            this.ligandoDatos()
            this.configurandoNodos(this.data_nodos);
            this.configurandoEnlaces(this.data_enlaces);
            this.context.globalAlpha = .8
            this.dibujandoCanvas();


            
            //this.simulacion.on('tick',() => this.actualizandoPosiciones(tiempo_fin_simulacion,this.simulacion));
        });
    window.addEventListener('resize', this.reescalandoPantalla);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reescalandoPantalla);

  },
  computed: {
    ...mapState([
        'data_clusters_seguro_social', "data_clusters_sexo", "data_clusters_edad",
        "numero_clusters", "numero_nodos_clusters", "categorias_distancias_geneticas"
    ]),
    ...mapGetters(["obtenerFechaActualizacion"]),
    vistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    },
  },
  methods: {
    reescalandoPantalla(){
        this.configurandoDimensionesCanvas()
        this.creandoEscalas();
        this.configurandoNodos(this.data_nodos);
        this.configurandoEnlaces(this.data_enlaces);
        this.context.globalAlpha = .8
        this.context.clearRect(-this.margen.izquierda, -this.margen.arriba, this.ancho + this.margen.derecha + this.margen.izquierda, this.alto + this.margen.abajo + this.margen.arriba);
        this.dibujandoCanvas();
        this.creandoEjes();
    },
    
    ligandoDatos(){
        this.detachedContainer = document.createElement("custom")
        this.dataContainer = d3.select(this.detachedContainer)
    },
    configurandoEnlaces(datums_enlaces){
        //Antes debe ir configurandoDimensionesCanvas -> creandoEscalas

        let frac_ancho = .2
        let frac_alto = .2
        this.dataContainer
            .selectAll("custom.beziers").remove();
        this.dataBinding = this.dataContainer
            .selectAll("custom.beziers")
            .data(datums_enlaces, function(d){return d})
            .enter()
            .append("custom")
            .classed("beziers",true)
            .attr("x1",(d) => d.source[this.columna_visualizar] ? this.escalaHorizontal(d.source[this.columna_visualizar]): this.ancho + .5 * this.margen.derecha )
            .attr("y1",(d) => this.escalaVertical(d.source.fech))
            .attr("x2",(d) => {
                let x1 = d.source[this.columna_visualizar] ? this.escalaHorizontal(d.source[this.columna_visualizar]): this.ancho + .5 * this.margen.derecha;
                let x2 = d.target[this.columna_visualizar] ? this.escalaHorizontal(d.target[this.columna_visualizar]): this.ancho + .5 * this.margen.derecha
                let x_min = d3.min([x1, x2]);
                let distancia = Math.abs(x1 - x2);
                return x_min + distancia * (x1 < x2 ? frac_ancho: 1-frac_ancho)
            })
            .attr("y2",(d) => {
                let y1 = this.escalaVertical(d.source.fech);
                let y2 = this.escalaVertical(d.target.fech);
                let y_min = d3.min([y1, y2]);
                let distancia = Math.abs(y1 - y2);
                return y_min + distancia * (y1 > y2 ? frac_alto: 1-frac_alto)

            })
            .attr("x3",(d) => {
                let x1 = d.source[this.columna_visualizar] ? this.escalaHorizontal(d.source[this.columna_visualizar]): this.ancho + .5 * this.margen.derecha;
                let x2 = d.target[this.columna_visualizar] ? this.escalaHorizontal(d.target[this.columna_visualizar]): this.ancho + .5 * this.margen.derecha;
                let x_min = d3.min([x1, x2]);
                let distancia = Math.abs(x1 - x2);
                return x_min + distancia * (x1 >= x2 ? frac_ancho: 1-frac_ancho)
            })
            .attr("y3",(d) => {
                let y1 = this.escalaVertical(d.source.fech);
                let y2 = this.escalaVertical(d.target.fech);
                let y_min = d3.min([y1, y2]);
                let distancia = Math.abs(y1 - y2);
                return y_min + distancia * (y1 <= y2 ? frac_alto: 1-frac_alto)

            })
            .attr("x4",(d) => d.target[this.columna_visualizar] ? this.escalaHorizontal(d.target[this.columna_visualizar]): this.ancho + .5 * this.margen.derecha)
            .attr("y4",(d) => this.escalaVertical(d.target.fech))
            .attr("setLineDash", (d) => this.escalaDashLinks(d.distancia))
            .attr('strokeStyle', (d) => this.escalaColorLinks(d.distancia))
            
    },
    configurandoNodos(datums_nodos){
        //Antes debe ir configurandoDimensionesCanvas -> creandoEscalas
        this.dataContainer
            .selectAll("custom.ellipse")
            .remove()
        this.dataBinding = this.dataContainer
            .selectAll("custom.ellipse")
            .data(datums_nodos, function(d){return d})
            .enter()
            .append("custom")
            .classed("ellipse",true)
            .attr("x",(d) => d[this.columna_visualizar] ? this.escalaHorizontal(d[this.columna_visualizar]): this.ancho + .5 * this.margen.derecha )
            .attr("y",(d) => this.escalaVertical(d.fech))
            .attr("r1",(d) => Math.sqrt(this.escalaRadial(d.grado)))
            .attr("r2",(d) => Math.sqrt(this.escalaRadial(d.grado)))
            .attr("fillStyle",(d) => this.dicColores[d.resistencia])
            .attr("shadowBlur", d=> (d.grado)/2)
            .attr("shadowColor","#fff")
    },
    reconfigurandoEnlaces(datums_enlaces){
        //Antes debe ir configurandoDimensionesCanvas -> creandoEscalas
        let frac_ancho = .2
        this.dataContainer
            .selectAll("custom.beziers")
            .transition()
            .duration(1000)
            .attr("x1",(d) => this.escalaHorizontal(d.source[this.columna_visualizar]))
            .attr("x2",(d) => {
                let x1 = this.escalaHorizontal(d.source[this.columna_visualizar]);
                let x2 = this.escalaHorizontal(d.target[this.columna_visualizar])
                let x_min = d3.min([x1, x2]);
                let distancia = Math.abs(x1 - x2);
                return x_min + distancia * (x1 < x2 ? frac_ancho: 1-frac_ancho)
            })
            
            .attr("x3",(d) => {
                let x1 = this.escalaHorizontal(d.source[this.columna_visualizar]);
                let x2 = this.escalaHorizontal(d.target[this.columna_visualizar])
                let x_min = d3.min([x1, x2]);
                let distancia = Math.abs(x1 - x2);
                return x_min + distancia * (x1 >= x2 ? frac_ancho: 1-frac_ancho)
            })
            
            .attr("x4",(d) => this.escalaHorizontal(d.target[this.columna_visualizar]))
            
    },
    reconfigurandoNodos(datums_nodos){
        //Antes debe ir configurandoDimensionesCanvas -> creandoEscalas
         this.dataContainer.selectAll("custom.ellipse")
            .transition()
            .duration(1000)
            .attr("x",(d) =>  d[this.columna_visualizar] ? this.escalaHorizontal(d[this.columna_visualizar]): this.ancho)
    },
    
    dibujandoCanvas(){
        let self = this
        self.context.save()
        self.context.clearRect(-this.margen.izquierda, -this.margen.arriba, this.ancho + this.margen.derecha + this.margen.izquierda, this.alto + this.margen.abajo + this.margen.arriba);


        var enlaces = this.dataContainer.selectAll("custom.beziers")
        enlaces.each(function(d){
            var enlace = d3.select(this)
            self.context.beginPath();
            self.context.strokeStyle = enlace.attr("strokeStyle");
            if(enlace.attr("setLineDash")){
                self.context.setLineDash(enlace.attr("setLineDash").split(",").map(dd=>parseInt(dd)))
            }else{
                self.context.setLineDash([])
            }
            self.context.lineWidth = 1;

            self.context.moveTo(enlace.attr("x1"),enlace.attr("y1"));
            self.context.bezierCurveTo(
                enlace.attr("x2"), enlace.attr("y2"),
                enlace.attr("x3"), enlace.attr("y3"),
                enlace.attr("x4"), enlace.attr("y4")
            );
            self.context.stroke();
        	self.context.closePath();
        })

        var nodos = this.dataContainer.selectAll("custom.ellipse")
        nodos.each(function(d){
            var nodo = d3.select(this)
            self.context.moveTo(nodo.attr("x") + nodo.attr("r1"), nodo.attr("y"));
            self.context.fillStyle = nodo.attr("fillStyle");

            self.context.shadowBlur = nodo.attr("shadowBlur");
            self.context.shadowColor = nodo.attr("shadowColor");

            self.context.beginPath();
            

            self.context.ellipse(
                nodo.attr("x"), nodo.attr("y"), 
                nodo.attr("r1"), nodo.attr("r2"),
                0,
                0, 2 * Math.PI);
            
            self.context.fill();
        	self.context.closePath();
        })
        self.context.restore();
        this.loader_visible = false
    },

    configurandoDimensionesCanvas() {


        var dpr = Math.min(2, getPixelRatio(this.context))
        
        this.ancho = document.querySelector('.contenedor-tooltip-svg').clientWidth - this.margen.derecha - this.margen.izquierda;

        this.alto = this.ancho * 2 ;
        
        d3.select("#"+this.id_red_temporal +" .rotation-wrapper-outer .element-to-rotate")
            .style("width", (this.alto + this.margen.arriba + this.margen.abajo)+ "px")
        this.ancho_leyenda_y = document.querySelector("#"+this.id_red_temporal +" .rotation-wrapper-outer .element-to-rotate")
                    .clientHeight
        this.ancho = document.querySelector('.contenedor-tooltip-svg').clientWidth - this.margen.derecha - this.margen.izquierda - this.ancho_leyenda_y;
        
        this.alto = (this.ancho * 2 >800)? this.ancho * 2 - this.margen.arriba - this.margen.abajo: 800;
        d3.select("#"+this.id_red_temporal +".contenedor-tooltip-svg")
            .style("height",(this.alto + this.margen.arriba + this.margen.abajo)+"px")
        this.canvas
            .attr("width", (this.ancho + this.margen.derecha + this.margen.izquierda) * dpr)
            .attr("height", (this.alto + this.margen.arriba + this.margen.abajo) * dpr)
            .style("width", (this.ancho + this.margen.derecha + this.margen.izquierda) + "px")
            .style("height", (this.alto + this.margen.arriba + this.margen.abajo) + "px")
            .style("left", this.ancho_leyenda_y +"px");
        this.svg.attr("width", this.ancho + this.margen.derecha + this.margen.izquierda)
            .attr("height", (this.alto + this.margen.arriba + this.margen.abajo))
            .style("height", (this.alto + this.margen.arriba + this.margen.abajo) + "px")
            .style("left", this.ancho_leyenda_y +"px");
        this.rectangulo_over
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", this.ancho + this.margen.derecha + this.margen.izquierda)
            .attr("height", (this.alto + this.margen.arriba + this.margen.abajo))
            .style("fill", "none")
            .style("pointer-events", "all")

        this.grupo_sin_dato
            .attr("transform",`translate(${this.ancho + this.margen.izquierda + .25*this.margen.izquierda},${this.margen.arriba})`)
        this.grupo_sin_dato.select("rect")
            .attr("width", .5*this.margen.derecha)
            .attr("height",this.alto)
            .attr("x",0)
            .attr("y",0)
            .style("fill-opacity",".3")
        this.grupo_sin_dato.select("text")
            .text("Sin info")
            .attr("x",5)
            .attr("y",.25*this.margen.derecha)
            .style("fill","#000")
            .style("dominant-baseline","middle")
            .style("font-size","10px")
            .style("transform","rotate(-90deg)")
        //this.context = this.canvas.node().getContext("2d")
        this.context.scale(dpr,dpr)
        this.context.translate(this.margen.izquierda , this.margen.arriba)
        
    },
    
    creandoSimulacion() {
        this.simulacion = d3.forceSimulation(this.data_nodos)
            .force('link', d3.forceLink().id((d) => d.id).links(this.data_enlaces).strength(0))
            
    },
    creandoShadows(){
        this.defs
            .append("filter")
            .attr("id", "shadow")
            .attr("x", "-50%")
            .attr("y", "-50%")
            .attr("width", "200%")
            .attr("height", "200%")
            .append("feDropShadow")
            .attr("stdDeviation", "2")
            .attr("dx", "0")
            .attr("dy", "0")
            .attr("flood-color", "#000")//(d) => this.dicColores[d])
    },
    
    creandoEscalas() {
        
        this.escalaVertical = d3.scaleTime()
            .domain(d3.extent(this.data_nodos.map(d=>d.fech)))
            .range([ this.alto, 0])
        this.escalaHorizontal = d3.scaleLinear()
            .domain(d3.extent(this.data_nodos.map(d=>d[this.columna_visualizar])))
            .range([0, this.ancho])
        this.escalaRadial = d3.scaleLinear()
            .domain(d3.extent(this.data_nodos.map(d=>d.grado)))
            .range([(10 * this.factor_escala_radial * this.ancho * this.alto)/d3.max(this.data_nodos.map(d=>d.grado)), 10 * this.factor_escala_radial * this.ancho * this.alto]);
        this.cortes_grado.forEach(d=>{
            d.diametro = 2 * Math.sqrt(this.escalaRadial(d.valor))
        })
        this.escalaColorLinks = d3.scaleQuantize()
            .domain([0,1.5])
            .range(this.cortes_distancia_genetica.map(d=>d.stroke_color))
        this.escalaAnchoLinks = d3.scaleQuantize()
            .domain([0,1.5])
            .range(this.cortes_distancia_genetica.map(d=>d.stroke_width))
        this.escalaDashLinks = d3.scaleQuantize()
            .domain([0,1.5])
            .range(this.cortes_distancia_genetica.map(d=>d.dash_array.split(",")))
        this.creandoVoronoi()
        
        
    },
    creandoVoronoi(){
        const puntos = this.data_nodos.map(d => [(d[this.columna_visualizar] ? this.escalaHorizontal(d[this.columna_visualizar]): this.ancho) + this.margen.izquierda, this.escalaVertical(d.fech)+ this.margen.arriba]);
            this.delaunay =  d3.Delaunay
                .from(puntos)
            this.voronoi = this.delaunay.voronoi([0, 0, 
                    this.ancho + this.margen.derecha + this.margen.izquierda,
                    this.alto + this.margen.arriba + this.margen.abajo]);
            this.svg.select("path.voronoi").remove()
            /*const mesh = this.svg.append("path")
                .attr("class","voronoi")
                .attr("fill", "none")
                .attr("stroke", "rgb(50,50,255)")
                .attr("stroke-width", 1)
                .attr("d", this.voronoi.render())*/
            
           this.rectangulo_over
                .on("mousemove",(e)=>{this.overNodo(e)})
                .on("click",(e)=>{this.clickeandoNodo(e)})
                .on("mouseout",(e)=>{this.outNodo()})
    },
    creandoEjes(){
        this.eje_x.attr("transform",`translate(${this.margen.izquierda}, ${this.margen.arriba})`).call(d3.axisTop(this.escalaHorizontal));
        this.eje_x.selectAll("g line").remove()
        this.eje_x.selectAll("path").remove()
        
        this.eje_y.attr("transform",`translate(${this.margen.izquierda}, ${this.margen.arriba})`)
            .call(
                d3.axisLeft(this.escalaVertical)
                    .ticks(5)
			        .tickFormat(this.multiFormat));
        this.eje_y.selectAll("g line").remove()
        this.eje_y.selectAll("path").remove()
        this.eje_y.selectAll("text")
            .style("transform","rotate(-90deg)")
            .style("text-anchor","middle")
            .style("dominant-baseline","middle")
            .attr("x",0)
            .attr("dy",-15)
    },
    ocultandoTodosLosNodos(){
        this.context.clearRect(-this.margen.izquierda, -this.margen.arriba, this.ancho + this.margen.derecha + this.margen.izquierda, this.alto + this.margen.abajo + this.margen.arriba);
        this.context.globalAlpha = .01
        this.dibujandoCanvas();
    },
    mostrandoClusterSeleccionado(indice){
        
        let cluster_id = this.data_nodos[indice].cluster_id;
        let self = this
        
        self.context.save()


        var enlaces = this.dataContainer.selectAll("custom.beziers")
            .filter(d=> d.cluster_id == cluster_id)

        enlaces.each(function(d){
            var enlace = d3.select(this)
            self.context.beginPath();
            self.context.strokeStyle = enlace.attr("strokeStyle");
            if(enlace.attr("setLineDash")){
                self.context.setLineDash(enlace.attr("setLineDash").split(",").map(dd=>parseInt(dd)))
            }else{
                self.context.setLineDash([])
            }
            self.context.lineWidth = 1;

            self.context.moveTo(enlace.attr("x1"),enlace.attr("y1"));
            self.context.bezierCurveTo(
                enlace.attr("x2"), enlace.attr("y2"),
                enlace.attr("x3"), enlace.attr("y3"),
                enlace.attr("x4"), enlace.attr("y4")
            );
            self.context.stroke();
        	self.context.closePath();
        })

        var nodos = this.dataContainer.selectAll("custom.ellipse")
            .filter(d=> d.cluster_id == cluster_id)
        
        nodos.each(function(d){
            var nodo = d3.select(this)
            self.context.moveTo(nodo.attr("x") + nodo.attr("r1"), nodo.attr("y"));
            self.context.fillStyle = nodo.attr("fillStyle");

            self.context.shadowBlur = nodo.attr("shadowBlur");
            self.context.shadowColor = nodo.attr("shadowColor");

            self.context.beginPath();
            

            self.context.ellipse(
                nodo.attr("x"), nodo.attr("y"), 
                nodo.attr("r1"), nodo.attr("r2"),
                0,
                0, 2 * Math.PI);
            
            self.context.fill();
        	self.context.closePath();
        })
        self.context.restore();
        self.busqueda_repetida = false;
        

    },
    clickeandoNodo(e){
        this.indice_nodo_clickeado = this.delaunay.find(e.layerX, e.layerY);
        this.nodo_clickeado = d3.select(this.dataContainer.selectAll("custom.ellipse")._groups[0][this.indice_nodo_encontrado])._groups[0][0].__data__
        console.log(!this.cluster_clickeado)
        if(!this.cluster_clickeado){
            this.ocultandoTodosLosNodos();
            this.context.globalAlpha = .8;
            this.mostrandoClusterSeleccionado(this.indice_nodo_clickeado);
            console.log(this.nodo_clickeado)
            this.cluster_clickeado = this.nodo_clickeado.cluster_id
        }
        else{
            this.cluster_clickeado = null;
            this.context.globalAlpha = .8;
            this.dibujandoCanvas();
        }
        


    },
    overNodo(e){
        this.indice_nodo_encontrado = this.delaunay.find(e.layerX, e.layerY);

        this.nodo_overeado = d3.select(this.dataContainer.selectAll("custom.ellipse")._groups[0][this.indice_nodo_encontrado]);

        this.circulo_over
            .attr("r", this.nodo_overeado.attr("r1"))
            .attr("cx", this.nodo_overeado.attr("x"))
            .attr("cy", this.nodo_overeado.attr("y"))
            .style("fill", this.nodo_overeado.attr("fillStyle"))
            .style("filter", `url(#shadow)`)
        this.posicionandoTooltip()
        
        
    },
    outNodo(){
        this.tooltip
            .style("visibility", "hidden")
              
    },
    cerrarTooltip(){
        this.tooltip
            .style("visibility", "hidden")
    },
    posicionandoTooltip(){
        let datums = this.nodo_overeado._groups[0][0].__data__;
        let posicion_horizontal =(this.margen.izquierda + parseInt(this.nodo_overeado.attr("x")))+ this.ancho_leyenda_y
        if(!this.cluster_clickeado){
           this.tooltip.style("visibility", "visible");
           this.circulo_over.style("visibility", "visible");
        }
        else{
            if(this.cluster_clickeado == datums.cluster_id){
               this.tooltip.style("visibility", "visible");
               this.circulo_over.style("visibility", "visible");
            }
            else{
                this.tooltip.style("visibility", "hidden");
                this.circulo_over.style("visibility", "hidden");
            }
        }
        this.tooltip
            .style("top",(this.margen.arriba + parseInt(this.nodo_overeado.attr("y"))) +"px")
            .style("left",`${posicion_horizontal < .3* this.ancho ? posicion_horizontal :
                posicion_horizontal < .7 * this.ancho ? posicion_horizontal - .5 * this.ancho_tooltip:
                posicion_horizontal - this.ancho_tooltip
            }px`)
        
        this.tooltip
            .select('div.tooltip-cuerpo')
            .html(`
                <p><b>Fecha de toma:</b> ${ datums.fech.getUTCDate()}/${lista_meses_abr[ datums.fech.getMonth()]}/${datums.fech.getFullYear()}</p>
                <p><b>Número de conexiones:</b> ${datums.grado}</p>
                <p><b>Resistencia:</b> <span class="span-tooltip-color" style="background: ${this.dicColores[datums.resistencia]}"></span>${datums.resistencia}</p>
                <p><b>Edad:</b> ${datums.edad} años</p>
                <p><b>Género:</b> ${datums.sexo}</p>
            `)
    },
    multiFormat(date) {
				/**
				 * Método para traducir el formato de fecha
				 */
				this.locale = d3.timeFormatLocale({
					"decimal": ",",
					"thousands": ".",
					"grouping": [3],
					"currency": ["€", ""],
					"dateTime": "%A, %e %B %Y г. %X",
					"date": "%d.%m.%Y",
					"time": "%H:%M:%S",
					"periods": ["AM", "PM"],
					"days": ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
					"shortDays": ["Dom", "Lun", "Mar", "Mi", "Jue", "Vie", "Sab"],
					"months": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
					"shortMonths": ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
				});
				this.formatMillisecond = this.locale.format(".%L");
				this.formatSecond = this.locale.format(":%S");
				this.formatMinute = this.locale.format("%I:%M");
				this.formatHour = this.locale.format("%I %p");
				this.formatDay = this.locale.format("%a %d");
				this.formatWeek = this.locale.format("%b %d");
				this.formatMonth = this.locale.format("%b");
				this.formatMonthYear = this.locale.format("%b/%Y");
				this.formatYear = this.locale.format("%Y");
				// console.log(date)
				return (d3.timeSecond(date) < date ? this.formatMillisecond
					: d3.timeMinute(date) < date ? this.formatSecond
					: d3.timeHour(date) < date ? this.formatMinute
					: d3.timeDay(date) < date ? this.formatHour
					: d3.timeMonth(date) < date ? (d3.timeWeek(date) < date ? this.formatDay : this.formatWeek)
					: d3.timeYear(date) < date ? this.formatMonthYear
					: this.formatMonthYear)(date);
				},
    

    
  },
};
//Find the device pixel ratio
function getPixelRatio(ctx) {
    //From https://www.html5rocks.com/en/tutorials/canvas/hidpi/
    let devicePixelRatio = window.devicePixelRatio || 1
    let backingStoreRatio = ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio || 1
    let ratio = devicePixelRatio / backingStoreRatio
    return ratio
}//function getPixelRatio
</script>

<style scoped lang='scss'>
$border-color: #333;
$border-radius-tarjeta:10px;

$padding: $gap * .5;

 div.contenedor-grafica {
    width: 100%;
    border: solid black 1px;
    border-radius: $border-radius-tarjeta $border-radius-tarjeta 0 0 ;
    position: relative;
    margin-bottom: 30px;
    &.content-viz{
        .summary {
            position: relative;
            z-index: 2;
			
				height: 30px;
				background:#000;
				color: #fff;
				text-align: center;
				font-size:12px;
				font-weight: 500;
				padding: 4px;
				width: 100%;
				border: solid 1px #000;
				border-radius:0;
				transition: all .27s ease-in-out;
				&:hover,
				&:focus,
				&:active {
					background-color: #000;
					color: #fff;
				}
			}
    }
    .tablero-cabecera {
        border-bottom: 1px solid $border-color;
        padding: $padding*.5 $padding;

        .titulo {
        font-size: 1.5em;
        line-height: 1.3;
        margin: 0;
        }
        .instruccional {
            margin: $padding*.5 0 0;
            display: flex;
            flex-direction: column;
            .fecha {
                display: block;
                margin-top: $padding*.5;
                font-size: 12px;
            }

            @media (min-width: map-get($media-queries-limit, "mobile")) {
                flex-direction: row;
                justify-content: space-between;
                margin: 0;
                position: relative;

                .fecha {
                margin: 0;
                position: absolute;
                right: 0;
                bottom: 0;
                }
            }
        }
        
    }
    .tablero-cuerpo{
        position: relative;
        display: flex;
        overflow: hidden;

        &.open{
            height: auto;
            overflow: initial;
            @media (max-width: map-get($media-queries-limit, "mobile")) {
                overflow: hidden;
            }
            .panel-lateral-nomenclatura{
                top: 50px;
                @media (max-width: map-get($media-queries-limit, "mobile")) {
                    top: 0
                }
            }
        }
        height: 650px;
        @media (max-width: map-get($media-queries-limit, "mobile")) {
            display: block;
            height: 680px;
        }
       
        .panel-lateral-nomenclatura{
            max-height: 800px;
            top: 0px;
            max-width: 248px;
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            position: -webkit-sticky;
            position: sticky;
            margin: 0;
            transform: translate3d(0, 0, 0);
            z-index: 0;
            
            display: block;
            &>*{
                border-right: solid 1px #000;
            }
            @media (max-width: map-get($media-queries-limit, "mobile")) {
                border-right-width: 0;
                width: 100%;
                position: relative;
                top: 0;
                max-width: 100%;
                & > *{
                    border-radius: 0;
                    box-shadow: none;
                    border-right: none;

                }
            }
            
            .check-contenido{
                border-bottom: solid 1px #000;
            }
            .panel-porcentaje-muestra {
                padding: 5px 10px 5px 15px;
                border-bottom: 1px solid $border-color;
                display: flex;
                
                .porcentaje-descripcion {
                letter-spacing: -0.35px;
                font-size: 14px;

                .porcentaje-absoluto {
                    color: #000;
                    margin: 5px 0px;
                }
                .porcentaje-total {
                    color: #6B6B6B;
                    margin: 5px 0px;
                }
                }
            }

        }
        .contenedor-tooltip-svg{
            position: relative;
            width: calc(100% - 248px);
            flex: 1;
            display: block;
            z-index: 10;
            @media (max-width: map-get($media-queries-limit, "mobile")) {
                border-right-width: 0;
                max-width: 100%;
                width: 100%;
            }
            margin: 0;
            canvas{
                top:0;
                position: absolute;
            }
            .rotation-wrapper-outer {
                display: table;
                .rotation-wrapper-inner {
                    padding: 50% 0;
                    height: 0;
                    .element-to-rotate {
                        display: block;
                        transform-origin: top left;
                        //transform: rotate(-90deg) translate(-100%);
                        margin-top: -50%;
                        font-size: 12px;
                        text-align: center;
                        font-weight: 600;
                    }
                }
            }
            div.eje-x{
                position: relative;
                width: 100%;
                text-align: center;
                font-size: 12px;
                text-align: center;
                font-weight: 600;
            }
            svg#svg_red{
                position: absolute;
                top:0;
                left: 0;
                z-index:2
            }
            div.tooltip{
                z-index: 1;
                position: absolute;
                visibility: hidden;
                
                color:#fff;
                position: absolute;
                visibility: hidden;
                z-index: 2;
                div.tooltip-contenido{
                    background: rgba(0, 0, 0,.8);
                    color: #fff;
                    padding: 5px 15px;
                    font-size: 14px;
                    border-radius:8px
                }
                &::v-deep {
                    p{
                        margin: 5px 0;
                        span.span-tooltip-color {
                            width: 12px;
                            height: 12px;
                            border: solid 1px rgba(255, 255, 255, .7 );
                            display: inline-block;
                            border-radius: 50%;
                            margin-right: 5px;
                        }
                    }
                }
                div.tooltip-encabezado{
                    height: auto;
                    display: flex;
                    width: 100%;
                    padding-top:5px;
                    font-weight: 600;
                }
                button.boton-cerrar-tooltip{
                    background: none;
                    border:none;
                    padding: 0;
                    margin: 0 0 0 auto;
                    @media (min-width: 768px) {
                        display: none;	
                    }
                    cursor:pointer;
                    img{
                        width:30px;
                        height: 30px;
                        float:right;
                    }
                }

            }
            
        }
    }
    
    
	
}

</style>
